module.exports = __webpack_public_path__ + "img/点播视频管理.457d0a51.png";